import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './Estado.css'

export default function Estado() {
    const [estado, setEstado] = useState(null);
    const [idEstado, setIdEstado] = useState(null);

    useEffect(() => {
        const fetchEstado = async () => {
            try {
                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();
                if (data.error) {
                    console.error(data.error);
                } else {
                    setEstado(data.estado);
                    setIdEstado(data.idEstado);
                }
            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };

        fetchEstado();
    }, []);

    const handleEditEstado = async () => {
        const { value: nuevoEstado } = await Swal.fire({
            title: 'Estado de tienda',
            input: 'select',
            inputOptions: {
                'Cerrado': 'Cerrado',
                'Abierto': 'Abierto',
                'Abierto + Pedidos': 'Abierto + Pedidos',
                'Abierto + Pedidos + WhatsApp': 'Abierto + Pedidos + WhatsApp',
                'Abierto + Pedidos de WhatsApp': 'Abierto + Pedidos de WhatsApp'
            },
            inputPlaceholder: 'Selecciona',
            showCancelButton: true
        });

        if (nuevoEstado && idEstado) {
            try {
                const response = await fetch(`${baseURL}/estado.php?idEstado=${idEstado}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ nuevoEstado })
                });

                const data = await response.json();
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('Actualizado', '', 'success');
                    setEstado(nuevoEstado);
                }
            } catch (error) {
                Swal.fire('Error', 'No se pudo actualizar', 'error');
            }
        }
    };

    const isOpen = estado && estado !== 'Cerrado';

    return (
        <div>
            {estado ? (
                <button className={isOpen ? 'Abierto' : 'Cerrado'} onClick={handleEditEstado}>
                    {estado}
                </button>
            ) : null}
        </div>
    );
}
